module.exports = __webpack_public_path__ + "media/images/flower_dollar-046817d131f5b8b5f80e488722d67b59.svg";